module.exports = __webpack_public_path__ + "img/mobile-app-preview.54bcf32c.png";